const base = '/management',
    basePath = `pages${base}`;
export default [
    {
        path:`/manager/index`,
        name:'managerIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/manager/index`)), 'managerIndex'),
        meta:{
            tit:'管理员设置'
        }
    },
    {
        path:`/manager/detail`,
        name:'managerDetail',
        component:r => require.ensure([], () => r(require(`@/${basePath}/manager/detail`)), 'managerDetail'),
        meta:{
            tit:'管理员设置详情'
        }
    },
    {
        path:`/group/index`,
        name:'groupIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/group/index`)), 'groupIndex'),
        meta:{
            tit:'管理组设置'
        }
    },
    {
        path:`/group/detail`,
        name:'groupDetail',
        component:r => require.ensure([], () => r(require(`@/${basePath}/group/detail`)), 'groupDetail'),
        meta:{
            tit:'管理组信息详情'
        }
    },
    {
        path:`/group/info`,
        name:'groupInfo',
        component:r => require.ensure([], () => r(require(`@/${basePath}/group/info`)), 'groupInfo'),
        meta:{
            tit:'管理组权限详情'
        }
    },
    {
        path:`/role/index`,
        name:'roleIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/role/index`)), 'roleIndex'),
        meta:{
            tit:'角色管理'
        }
    },
    {
        path:`/role/detail`,
        name:'roleDetail',
        component:r => require.ensure([], () => r(require(`@/${basePath}/role/detail`)), 'roleDetail'),
        meta:{
            tit:'角色详情'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/router/management.js